import React from 'react'

function Footer() {
  return (
    <div className="bg-bgPink flex-col-reverse sm:flex-row text-txColor w-full border-t-2 border-bgPinkSection flex justify-between py-5 sm:h-fit  px-4 lg:px-20">
      <p className="mt-5 sm:mt-0">© 2025 All rights reserved.</p>
      <p> sanarizgar34@gmail.com</p>
    </div>
  )
}

export default Footer
